import axios from 'axios';

const api = axios.create({
    baseURL: '/api',
    headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const gymId = localStorage.getItem('selected_gym_id');
    if (gymId && config.url?.startsWith('/owner/')) {
        if (['post', 'put', 'patch'].includes(config.method?.toLowerCase())) {
            if (config.data instanceof FormData) {
                config.data.append('gym_id', gymId);
            } else if (typeof config.data === 'object' && config.data !== null) {
                config.data = { ...config.data, gym_id: gymId };
            } else {
                config.params = { ...config.params, gym_id: gymId };
            }
        } else {
            config.params = { ...config.params, gym_id: gymId };
        }
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            window.dispatchEvent(new CustomEvent('auth:unauthorized'));
        }
        return Promise.reject(error);
    }
);

export default api;
